import React, {useEffect, useState} from "react";
import './Main.scss'
import classNames from "classnames";
import {MainNetInfo} from "../../server/swap/type";
import {WrapTokenWithCurrency} from "../../reducer/swap/type";
import {actionHandler} from "../../action/parseAction";
import {initSwapAction} from "../../action/swap/public";
import {Outlet, useLocation, useNavigate} from "react-router-dom";

const TABS = [
    {
        title: "Swap",
        path: '/swap'
    },
    {
        title: "History",
        path: '/history'
    }
]

const Main = () => {

    const location = useLocation();

    const navigate = useNavigate();


    const [swapData, setSwapData] = useState<{
        mainNetInfo: MainNetInfo;
        wrapTokens: Array<WrapTokenWithCurrency>;
    }>();

    // Effect
    useEffect(() => {
        actionHandler(initSwapAction(), setSwapData);
    }, []);

    useEffect(() => {
        if (location.pathname === '/') {
            navigate(TABS[0].path);
        }
    }, [navigate, location]);

    return (
        <div id={'Main'} style={{height: location.pathname === TABS[0].path ? '100%' : 'auto'}}>
            <header>
                {
                    TABS.map((tab) => {
                        return <button className={classNames('tab-button', {active: location.pathname === tab.path})}
                                       key={`${tab.title}`}
                                       onClick={() => navigate(tab.path)}>
                            {tab.title}
                        </button>
                    })
                }
            </header>
            <Outlet context={{swapData}}/>
        </div>
    )
}

export default Main
